import React from "react";
import { Button, Form } from "react-bootstrap";

export default function ConsentForm(props) {
  return (
    <>
      <p className="">
        Before we start our visit, our team uses a private, HIPAA-compliant transcription software that helps record the AUDIO of what we’re talking
        about and helps us transcribe this (or turn our talking into typed words). We use this to help with our documentation. Would it be ok if we
        use this software today during our visit?{" "}
      </p>

      {/* <Form.Check
        className="mr-20 mt-2"
        type="checkbox"
        label="Lorem ipsum dolor sit amet consectetur. Sociis eu eget lectus imperdiet iaculis.
"
        onChange={e => {}}
      />
      <Form.Check
        className="mr-20 my-2"
        type="checkbox"
        label="Lorem ipsum dolor sit amet consectetur. Sociis eu eget lectus imperdiet iaculis.
"
        onChange={e => {}}
      />
      <Form.Check
        className="mr-20"
        type="checkbox"
        label="Lorem ipsum dolor sit amet consectetur. Sociis eu eget lectus imperdiet iaculis.
"
        onChange={e => {}}
      /> */}

      <div className="group">
        <Button
          onClick={() => {
            props.setModalStage();
          }}
          className="primary-btn"
        >
          I have the patient consent
        </Button>
        <Button onClick={props.onHide} className="secondary-btn">
          Cancel
        </Button>
      </div>
    </>
  );
}
